//import React, { useEffect } from "react";
import { Button } from "../../../common/Button/Button";
//import Checkbox from "../../../common/Checkbox/Checkbox";
import {useEffect,useRef } from "react";
import select_arrow_down from "./../../../assets/select_arrow_down.svg";
import group from "./../../../assets/group.svg";
//import ColumnSectionDropdown from "../Admin/ColumnSelectionDropdown";
//import ShowMoreDropdown from "../Admin/ShowMoreDropdown";
import ShowMoreOptionDropdown from "../Admin/ShowMoreOptionDropDown";
import UserFacilitatorFeedbackModal from "./UserFacilitatorFeedbackModal";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../../common/Pagination/Pagination";
import { getServiceTypesMaster, getUser } from "../../../utils/localStorage";
import find from "lodash/find";
import moment from "moment";
import NeftModal from "../Handholder/NeftModal";
//import NotesFacilitatorViewModal from "./NotesFacilitatorViewModal";
//import NotesServiceFacilitatorViewModal from "./NotesServiceFacilitatorViewModel";
//import NotesServiceFacilitatorModal from "./NotesServiceFacilitatorModel";
import NotesResourcesModel from "./NotesResourcesModel";
import AssignServicePartnerModal from "./AssignServicePartnerModal";
//import AssignExternalServicePartnerModal from "./AssignExternalServicePartnerModal";
import AssignExternalServicePartnerModalNew from "./AssignExternalServicePartnerModalNew";
import copysvg from "./../../../assets/arrow_copy.svg";
import profilesvg from "./../../../assets/profile.svg";
import arrow_down from "./../../../assets/arrow_down.svg";
import { toast } from "react-toastify";
import ConfirmationModal from "./ConfirmationModal";
//import StateChangeModalSPM from "./StateChangeModalSPM";
import StateServiceChangeModalSPM from "./StateServiceChangeModalSPM";
import StateChangeLogModalSPM from "./StateChangeLogModalSPM";
import StateAuditLogDropdown from "./StateAuditLogDropdown";
import { URL_CALCULATOR } from "../../../utils/urls";
import { useState } from "react";
import { DND_LINK } from "../../../utils/constants";
import CancellationReasonModal from "../Handholder/CancellationReasonModal";
import Spinner from "../../../common/Spinner/Spinner";
import "../../../styles/tablecss.css"
import { ExportCSV } from "./ExportCSV";
const ReactTableFixedColumns = withFixedColumns(ReactTable);



//import { color } from "html2canvas/dist/types/css/types/color";


export default function MyResourceTable(props)
{
    // const [columnPage,setcolumnPage] =useState(0);
	// const [selectedColumnsCount,setSelectedColumnCount] =useState(0);

    

	const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

    const toggleStatusChangeModal = (e) => {
		if (e.nResourceInstanceId) props.onSelectServiceRequest(e);
		else props.onSelectServiceRequest(null);
		setShowStatusChangeModal(!showStatusChangeModal);
	};
	const [showStatusChangeLogModal, setShowStatusChangeLogModal] = useState(
		false
	);
	const toggleStatusChangeLogModal = (e) => {
		if (e.nResourceInstanceId) props.onSelectServiceRequest(e);
		else props.onSelectServiceRequest(null);
		setShowStatusChangeLogModal(!showStatusChangeLogModal);
	};
	const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);

	const toggleConfirmationModal = () => {
		setShowConfirmationModal(!showConfirmationModal);
	};
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [selectedStatus, setSelectedStatus] = useState({});
	const handleClick = (f, e) => {
		if (f.target.name !== undefined) {
			if (f.target.name === "cancelled") {
				props.toggleCancellationReasonModal();
				setSelectedStatus({ statusName: f.target.name, service: e });
			} else {
				toggleConfirmationModal();
				// toggleStatusChangeModal();
				setSelectedStatus({ statusName: f.target.name, service: e });
			}
		}
	};
	const changeState = () => {
		props.changeState(selectedStatus);
		if (selectedStatus.statusName !== "cancelled")
			toggleConfirmationModal();
	};

	function getReCalculateURL(
		sServiceState,
		paymentMode,
		nResourceInstanceId,
		catalogId
	) {
		let pricingAndProcessingMode = props.allCatalogs.filter(
			(e) => e["sCatalogueId"] === catalogId
		);
		let isDynamic = false;
		if (
			pricingAndProcessingMode.length > 0 &&
			pricingAndProcessingMode[0]["sMode"].split("_")[0] !== "DYNAMIC"
		) {
			isDynamic = true;
		}
		if (
			sServiceState === "Full Payment Received" ||
			sServiceState === "Delivered" ||
			paymentMode !== "2_Step_Payment" ||
			isDynamic
		) {
			return null;
		} else {
			return URL_CALCULATOR + String(nResourceInstanceId);
		}
	}
	function getReCalculateURLClassName(sServiceState, paymentMode, catalogId) {
		let pricingAndProcessingMode = props.allCatalogs.filter(
			(e) => e["sCatalogueId"] === catalogId
		);
		let isDynamic = false;
		if (
			pricingAndProcessingMode.length > 0 &&
			pricingAndProcessingMode[0]["sMode"].split("_")[0] !== "DYNAMIC"
		) {
			isDynamic = true;
		}
		if (
			sServiceState === "Full Payment Received" ||
			sServiceState === "Delivered" ||
			paymentMode !== "2_Step_Payment" ||
			isDynamic
		) {
			return "disableLink";
		} else {
			return "";
		}
	}




    const user = getUser();
	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};
    const NoDataComponent = (p) => {
        return <div>No data</div>;
    };


        const columns = [  

            {
                id: "sResourceID",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                Header: "User Profile Icon",
                accessor: "sResourceID",
                style: { 'whiteSpace': 'unset'},
                width: 100,
                //height:10,
                
                Cell: ({ original }) =>
                (
                    <>

                       
                         <img
                            //alt="copy"
                            src={profilesvg}
                            className="ellipse"
                            onClick={(e) => {props.toggleUserProfileModal(e, original);
                                props.setExpandedChange(this)
                            }}
                            // e.preventDefault();
                            // copyToClipboard(original.nResourceInstanceId);
                            //<a href="#" onClick={(e) => props.toggleUserProfileModal(e, original)} target="_self"></a>
                              
                        />
                    </>
                )                       
               
            },



            {
                id: "sResourceDisplayName",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
                style: { 'whiteSpace': 'unset'},
                Header: "Resource + Instance ID",
                accessor: "sResourceDisplayName",
                //width: 250,
               // height:10,
                Cell:({original})=>
                (
                    <>
                        {/* <span>{original.sResourceSubtype}</span> */}
                        <span>{original.sResourceDisplayName}</span>
                        <br></br> 
                        <br></br>
                        <span>ID: {original.nResourceInstanceId}</span>
                              
                    </>
                )
            },
            {
                id: "sOfferingName",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'10%'},
                style: { 'whiteSpace': 'unset'},
                Header: "Offering Detail",
                accessor: "sOfferingName",
                //width: 200,
                //height:10,
                Cell:({original})=>
                (
                    <>
                        {/* <span>{original.sResourceDisplayName}</span> */}
                        <span>{original.sOfferingName}</span>
                        <br></br> 
                        <br></br>
                        <span>
							{`ID:${
								original.sOfferingID ? 
								original.sOfferingID :
								""
								}`}
						</span>
                    </>
                )
            },

            {
                id: "sFirstName",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'10%'},
                style: { 'whiteSpace': 'unset'},
                Header: "Customer Name",
                accessor: "sFirstName",
                //width: 200,
                //height:10,
                Cell:({original})=>
                (
                    <>
                        <span>{original.sFirstName} {original.sLastName}</span>
                    </>
                )
            },
            // {
            //     id: "sEmailId",
            //     headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            //     style: { 'whiteSpace': 'unset'},
            //     Header: "Customer Detail",
            //     accessor: "sEmailId",
            //     width: 320,
            //     height:10,
            //     Cell:({original})=>
            //     (
            //         <>
            //             <span>{original.sEmailId}</span>
            //             <br></br>
                        
            //             <br></br>
            //             <span>{original.sContactNumber}</span>
                              
            //         </>
            //     )
            // },
            {
                id: "sEmailId",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'60%'},
                style: { 'whiteSpace': 'unset'},
                Header: "Customer Detail",
                accessor: "sEmailId",
               //width: 300,
                //height:10,
                Cell:({original})=>
                (
                    <>
                        <div className={"conv-float-left"}>
                                <div>
                                    <span className="conv-float-left conv-mr18 lpm-service-grid-key"></span>
                                    {
                                        original.sEmailId?
                                        (
                                            <>
                                                <img
                                                    alt="copy"
                                                    src={copysvg}
                                                    height={"20px"}
                                                    width={"16px"}
                                                    className="con-cursor-pointer conv-mr13 conv-ml10"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        copyToClipboard(original.sEmailId);
                                                        toast(`${
                                                            original.sFirstName ? 
                                                            original.sFirstName :
                                                            ""
                                                        }${' '}
                                                        ${
                                                            original.sLastName ? 
                                                            original.sLastName :
                                                            ""
                                                        }'s Email Copied!`, {
                                                            autoClose: 5000,
                                                            type: toast.TYPE.SUCCESS,
                                                        });
                                                    }}
                                                />
                                                <span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"166px"}}>
                                                    
                                                    {
                                                        original.sEmailId
                                                    }
                                                </span><br></br>
                                            </>
                                        )
                                        :
                                        ("NA")
                                    }
                                </div>
                                <div style={{"clear":"both"}}></div>
                                <div className="conv-mt10">
                                <span className="conv-float-left conv-mr5 lpm-service-grid-key"></span>
                                    {
                                        original.sContactNumber?
                                        (
                                            <>
                                                <img
                                                    alt="copy"
                                                    src={copysvg}
                                                    height={"20px"}
                                                    width={"16px"}
                                                    className="con-cursor-pointer conv-mr13 conv-ml10"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        copyToClipboard(original.sContactNumber);
                                                        toast(`${
                                                            original.sFirstName ? 
                                                            original.sFirstName :
                                                            ""
                                                        }${' '}
                                                        ${
                                                            original.sLastName ? 
                                                            original.sLastName :
                                                            ""
                                                        }'s Contact Copied!`, {
                                                            autoClose: 5000,
                                                            type: toast.TYPE.SUCCESS,
                                                        });
                                                    }}
                                                />
                                                <span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"167px"}}>										
                                                    {
                                                        original.sContactNumber
                                                    }
                                                </span>
                                            </>
                                        )   
                                        :
                                        ("")
                                    }
                                </div>
                            </div>
                    </>
                )  
            },

            {
                id: " ",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset'},
                Header: "Know More",
                accessor: " ",
                width: 105,
                //height:10,
                Cell: ({ original }) => 
                original["sResourceID"] ?(
                    <div className="col">	 
                        <div className="search-by con-cursor-pointer"
                            onClick={()=>{
                                props.onKnowMoreClick(original);
                            }}
                        >
                            
                            <img
                                alt=""
                                src={group}
                                height={"12px"}
                                width={"30px"}
                                className="conv-mr10"
                            /> 
                        </div>
                            {
                            props.isSearchByDropdownOpens && props.selectedServiceForKnowMore&&props.selectedServiceForKnowMore.nResourceInstanceId===original.nResourceInstanceId&&
                            <div id={original.sEmailId} className="spm-searches-by" ref={props.SearchsDropdownRef}>
                                <ShowMoreOptionDropdown
                                    isOpen={props.isSearchByDropdownOpens}
                                    toggleSelection={props.selectSearchBySelection}
                                    toggleNotesModal={props.toggleNotesModal}
                                    toggleShowFeedbackModal={props.toggleShowFeedbackModal}
                                    selectedServiceForKnowMore={props.selectedServiceForKnowMore}
                                    //checkboxItemsList={props.SearchByDropdownList}								
                                />
                            </div>
					        }	
                    </div>
                ): (
                    <span></span>
                ),
            },
            


         ];
                 
    
    return (
		<>
        {props.isLoadingSpinnerForMyResourceAssignment && (
				<>
					<Spinner className="center" />
				</>
			)}
		<div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container hide-expander conv-mt70`}>                        
				        <ReactTableFixedColumns
                                minRows={0}
                                data={props.data || []}
                                columns={columns}
                                manual
                                defaultPage={props.page}
                                pages={props.pages}
                                page={props.page}
                                pageSize={props.pageSize}
                                sortable={false}
                                defaultPageSize={10}
                                showPagination={true}
                                pageSizeOptions={[10,20,30,50,75,100]}
                                onFetchData={(state, instance) => {
                                    props.onFetchServiceRequests(instance, false);
                                }}
                                onPageSizeChange={props.onPageSizeOptionChange}
                                PaginationComponent={Pagination}
                                style={{overflowY: "initial",height: "800px"}}			
                                className="-striped hide-scrollbar overflowcss"
                                SubComponent={row => 
                            {
                            return (
                                <div className="row conv-pt20 conv-pl15 conv-bg-f8f8f8 conv-mr0"
                                    onClick={(e) => {let val=row.original;}}
                                >
                                    <div className="col-12 ">
                                        {/* <span className="spled-info-title">Information</span> */}
                                        <div className="row conv-pb12">
                                            <div className="col-5 conv-ml90 conv-mr60 conv-pl98">
                                             <span className="spled-info-title">Information</span>
                                                <div className="row conv-pb10 conv-pt10 ">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Progressed on date</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{moment(
                                                  moment.utc(row.original.dtRequested).toDate()
                                                 ).format("Do MMMM YYYY h:mm:ss a" )} </span>
                                                    </div>
                                                </div>

                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Facilitator Assigned On</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">
                                                        {moment(moment.utc(row.original.dtFacilitatorAssign).toDate()).format("Do MMMM YYYY h:mm:ss a")}
                                                             </span>
                                                    </div>
                                                </div>
                                                 
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Device Type</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sDeviceType}</span>
                                                    </div>
                                                </div>
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Payment Status</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sPaymentStatus ? " ": "NA"}</span>
                                                    </div>
                                                </div>
                                                
                                                <span className="spled-info-title">Business Detail</span>
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Business Name</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sBusinessName }</span>
                                                    </div>
                                                </div>

                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Business Name</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sBusinessSector}</span>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-5 conv-ml40 conv-pl50">
                                            <span className="spled-info-title">EHH Details</span>
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">EHH Email</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sExternalHHEmail ? " ": "NA"}</span>
                                                    </div>
                                                </div>

                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">EHH Contact No</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sEhhContactNumber ? " ": "NA"}</span>
                                                    </div>
                                                </div>
                                                 
                                                {/* <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">EHH Org</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sEhhOrg ? " ": "NA"}</span>
                                                    </div>
                                                </div> */}
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Stay Engaged with EHH</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.bStayEngagedWithEhh ? "Yes" : "No"}</span>
                                                    </div>
                                                </div>
                                                
                                                <span className="spled-info-title">Coupon Detail</span>
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Coupon Applied</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.bCouponApplied ? "Yes" : "No"}</span>
                                                    </div>
                                                </div>



                                                <div className="row conv-pb10 conv-pt10">
                                                    
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Coupon Code</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.sCouponCode ? " ": "NA"}</span>
                                                    </div>
                                                </div>

                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Coupon Discount Amount</span>
                                                    </div>
                                                    <div className="col-6">
                                                        <span className="spled-black-text">{row.original.fDiscountAmount ? " " : "NA"}</span>
                                                    </div>
    
                                                </div>
                                                <div className="row conv-pb10 conv-pt10">
                                                    <div className="col-6">
                                                        <span className="spled-colored-label">Resource PDF Link</span>
                                                    </div>

                                                    <div className="col-6">
                                                    <a href={row.original.sResourcePDFLink} target="_blank">
                                                    <span className="label-link">PDF Link</span>
                                                    </a>
                                                    </div>
                                                     
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                     
                                </div>
                            );
                          }}
                           

                	    />

                                <NotesResourcesModel
                                    auditTrail={props.auditTrail}
                                    changeSelectedNotesDetails={props.changeSelectedNotesDetails}
                                    notesHistory={props.notesHistory}
                                    notesDetails={props.notesDetails}
                                    isOpen={props.showNotesModal}
                                    toggleModal={props.toggleNotesModal}
                                    onInputChange={props.onNotesChange}
                                    onSaveNotesDetails={props.onSaveNotesDetails}
                                    isOpenConfirmationModal={props.showConfirmationModalNotes}
                                    toggleConfirmationModal={props.toggleConfirmationModalNotes}
                                    confirmChangeNotes={props.confirmChangeNotes}
                                    /*Need to talk to SP */
                                    needToTalkToSPOptions={props.needToTalkToSPOptions}
                                    selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
                                    setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
                                    service={props.selectedServiceRequest}
                                    onUpdateNeedToTalkToSPFlag={props.onUpdateNeedToTalkToSPFlag}
                                    /*End*/
                                />

                                <ShowMoreOptionDropdown
                                     
                                     isOpen={props.isSearchByDropdownOpens}
                                     toggleSelection={props.selectSearchBySelection}
                                     
                                  />

                        </div>
                </div>
		</div>
			
		</>
	);
}
